import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { decorateWith, withName } from 'helpers/decorator';
import { ga } from 'helpers/multitrack';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import media from 'decorators/Media/Media';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { messages } from './PressTestimonials.messages';
var mainImg = {
  desktop: require('../../../static/img/mock-data/pricing/press/main-image-dektop.png'),
  mobile: require('../../../static/img/mock-data/pricing/press/main-image.png')
};
var quotes = [{
  copy: messages.quoteNYT,
  image: require('../../../static/img/mock-data/pricing/press/logo-nyt.png'),
  source: 'The New York Times'
}, {
  copy: messages.quoteWG,
  image: require('../../../static/img/mock-data/pricing/press/logo-wg.png'),
  source: 'Well + Good'
}];
export var PressTestimonialsUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(PressTestimonialsUnwrapped, _Component);

  function PressTestimonialsUnwrapped(props) {
    var _this;

    _classCallCheck(this, PressTestimonialsUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PressTestimonialsUnwrapped).call(this, props));
    _this.renderQuote = _this.renderQuote.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PressTestimonialsUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('Press Module', 'Viewed press module', '', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "renderQuote",
    value: function renderQuote(quote) {
      var intl = this.props.intl;
      var copy = quote.copy,
          image = quote.image,
          source = quote.source;
      return React.createElement("div", {
        key: source
      }, React.createElement("blockquote", {
        className: "PressTestimonials__quote"
      }, React.createElement(FormattedMessage, copy)), React.createElement("img", {
        alt: intl.formatMessage(messages.altQuoteLogo, {
          source: source
        }),
        src: image
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          intl = _this$props.intl,
          mediaQueryMd = _this$props.mediaQueryMd;
      return React.createElement(Section, {
        className: "PressTestimonials"
      }, React.createElement(Heading, {
        className: "PressTestimonials__header"
      }, React.createElement(FormattedMessage, messages.pressHeader)), React.createElement("div", {
        className: "PressTestimonials__quotes"
      }, quotes.map(this.renderQuote)), React.createElement("div", {
        className: "PressTestimonials__mosaic"
      }, React.createElement("img", {
        alt: intl.formatMessage(messages.altPressLogos),
        src: mediaQueryMd ? mainImg.desktop : mainImg.mobile
      })));
    }
  }]);

  return PressTestimonialsUnwrapped;
}(Component);
PressTestimonialsUnwrapped.propTypes = {
  mediaQueryMd: PropTypes.bool,
  intl: intlShape.isRequired
};
export var PressTestimonials = decorateWith(injectIntl, media, trackDwell, withName('PressTestimonials'))(PressTestimonialsUnwrapped);